export default class ImageNotGeoreferenced extends Error {
  constructor(filename) {
    super(`The image ${filename} is not georeferenced.`)
  }
}
